module.exports = __webpack_public_path__ + "img/token-img.79afea4a.png";